const Exchange = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="#fff"
      d="M18.825 18.286c0 2.328-1.912 2.642-2.25 2.684v1.33h-1.002v-1.33c-.312-.043-2.411-.273-2.411-3.165h1.89c0 
        1.708.881 1.637 1.015 1.637.147 0 .868-.027.868-1.143 0-2.229-3.459-1.24-3.459-4.581 0-2.29 1.898-2.647 
        2.237-2.69V9.6h1.008v1.456c.321.061 2.117.471 2.117 3.098h-1.89c0-1.373-.583-1.589-.828-1.589-.134 
        0-.755.035-.755 1.162.001 1.967 3.46 1.354 3.46 4.559Z"
    />
    <path
      stroke="#fff"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M23 21.65A8.986 8.986 0 0 1 16 25c-4.962 0-9-4.038-9-9m2-5.65A8.986 8.986 0 0 1 16 7c4.962 0 9 4.038 9 9"
    />
    <path fill="#fff" d="M7 7v5h5L7 7ZM25 25v-5h-5l5 5Z" />
  </svg>
);

export default Exchange;
